import React from 'react';
import Layout from '../layouts/Layout';
import SEO from '../components/SEO';
import classNames from 'classnames';
import { Link, graphql } from 'gatsby';
import { GatsbyImage } from 'gatsby-plugin-image';
import ConditionalWrapper from '../components/ConditionalWrapper';

export default function PortfolioList({ location, data }) {
	const { i18NJson: i18n } = data;

	const metaTitle = i18n.titles.portfolio;
	const metaDescription = i18n.descriptions.portfolio;

	return (
		<Layout className="page-portfolio">
			<SEO
				pathname={location.pathname}
				title={metaTitle}
				description={metaDescription}
			/>

			<div className="screen screen-list screen-list--portfolio">
				<section className="main-content">
					<div className="jumbotron text-left">
						<div className="container">
							<h1 className="sub-title">
								{i18n.ui.portfolioAlt}
							</h1>
							<div className="description">
								<p>{i18n.descriptions.portfolio}</p>
							</div>
						</div>
					</div>

					<div className="container">
						<div className="list list--portfolio">
							{data.allMdx.edges.map(
								(
									{
										node: {
											id,
											fields: { slug },
											frontmatter,
										},
									},
									i,
								) => {
									const fluidThumb =
										frontmatter.thumb?.childImageSharp
											?.gatsbyImageData;

									return (
										<article
											key={id}
											className={classNames(
												'list-item',
												'list-item--portfolio',
											)}
										>
											<Link to={slug}>
												<figure>
													<div className="picture">
														<GatsbyImage
															image={fluidThumb}
															alt=""
														/>
													</div>
													<figcaption>
														<header>
															<h3 className="stitle">
																<span>
																	{
																		frontmatter.client
																	}
																</span>
															</h3>
															<h2 className="title">
																<span>
																	{
																		frontmatter.title
																	}
																</span>
															</h2>
															<div className="desc">
																<div className="desc__inner">
																	{
																		frontmatter.description
																	}
																</div>
															</div>

															<div className="link">
																<button className="btn btn-primary">
																	{
																		i18n.ui
																			.listItemBtnLabel
																	}
																</button>
															</div>
														</header>
													</figcaption>
												</figure>
											</Link>
										</article>
									);
								},
							)}
						</div>
					</div>
				</section>
			</div>
		</Layout>
	);
}

export const query = graphql`
	query portfolioListQuery($skip: Int!, $limit: Int!) {
		allMdx(
			filter: { fields: { collection: { eq: "portfolio" } } }
			sort: { frontmatter: { date: DESC } }
			limit: $limit
			skip: $skip
		) {
			edges {
				node {
					id
					fields {
						slug
					}
					frontmatter {
						title
						description
						client
						thumb {
							childImageSharp {
								gatsbyImageData(
									width: 800
									layout: CONSTRAINED
									quality: 60
								)
							}
						}
					}
				}
			}
		}
		i18NJson {
			ui {
				portfolioAlt
				listItemBtnLabel
			}
			titles {
				portfolio
			}
			descriptions {
				portfolio
			}
		}
	}
`;
